import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { BaseService } from "../base.service";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class ListService extends BaseService {
  constructor(http: Http, cookieService: CookieService) {
    super(http, cookieService);
    this.init("list");
  }

  list(filters?, sort?) {
    if (!filters) {
      filters = {};
    }
    filters["role"] = "customer";
    return super.list(filters, sort);
  }

  getUsersLists() {
    let headers = new Headers();
    let item = {};

    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    if (localStorage && localStorage.getItem("magic_link")) {
      headers.append("Authorization", localStorage.getItem("magic_link"));
    }
    if (localStorage && localStorage.getItem("cust_email")) {
      item["email"] = localStorage.getItem("cust_email");
    }

    return this.http
      .post(this.baseURL() + "/user", JSON.stringify(item), {
        headers: headers
      })
      .toPromise()
      .then(response => {
        return response.json();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/list/list.service.ts